exports.components = {
  "component---src-pages-fotogalerie-js": () => import("./../../../src/pages/fotogalerie.js" /* webpackChunkName: "component---src-pages-fotogalerie-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-potvrdit-ucast-js": () => import("./../../../src/pages/potvrdit-ucast.js" /* webpackChunkName: "component---src-pages-potvrdit-ucast-js" */)
}

